import { render, staticRenderFns } from "./CollaboratorSearchModal.vue?vue&type=template&id=23f5aec7&scoped=true"
import script from "./CollaboratorSearchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CollaboratorSearchModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CollaboratorSearchModal.vue?vue&type=style&index=0&id=23f5aec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5aec7",
  null
  
)

export default component.exports